module.exports = __webpack_public_path__ + "static/img/w.3e1e76a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/w.png
// module id = 5fEc
// module chunks = 1